import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from 'react-redux';
import { fetchSubSkills, getAllSubSkills, sortSubSkillsDesc, sortSubSkillsAsc } from '../../../../Redux/Actions/subSkillAction';
import { httpDeleteSubSkillset } from '../subSkills/api/calls'
import { fetchDepartment } from '../../../../Redux/Actions/departmentAction'

import SearchFilter from '../subSkills/SearchFilter';
import AddPopupModel from '../subSkills/AddPopupModel';
import Loader from "./Loader";
import Pagination from './Pagination';

const Table = () => {
    const dispatch = useDispatch();
    const { subSkills, getSkill, loading } = useSelector((state) => state.SubSkillReducers);
    const { departments } = useSelector((state) => state.departmentReducers);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedSkill, setSelectedSkill] = useState();
    const [sort, setSort] = useState('desc')

    useEffect(() => {
        dispatch(fetchSubSkills());
        dispatch(getAllSubSkills());
        dispatch(fetchDepartment())
    }, []);

    const postPerPage = 10;
    const totalPosts = subSkills?.length;

    const indexOfLastPost = currentPage * postPerPage;
    const indexOfFirstPost = indexOfLastPost - postPerPage;
    const filterSkillLists = subSkills?.slice(indexOfFirstPost, indexOfLastPost);


    const getDepartmentName = (id) => {
        return departments.find((dept) => dept.id === +id)?.name;
    };
    const handleUpdate = (skill) => {
        setSelectedSkill(skill);
    };
    const handleDelete = async (id) => {
        await httpDeleteSubSkillset(id).then((res) => {
            if (res.status) {
                dispatch(fetchSubSkills())
                return alert(res.msg);
            } else {
                return alert(res.msg);
            }
        });
    };
    const handleSorting = () => {
        if (sort === 'desc') {
            setSort('asc');
        }
        if (sort === 'asc') {
            setSort('desc');
        }
    }
    useEffect(() => {
        if (sort === 'desc') {
            dispatch(sortSubSkillsDesc());
        }
        if (sort === 'asc') {
            dispatch(sortSubSkillsAsc());
        }
    }, [sort, dispatch]);






    return (
        <>
            <div className="row_bg">
                <AddPopupModel departments={departments} skillArr={getSkill} skillID={selectedSkill} setSelectedSkill={setSelectedSkill} />
                <SearchFilter departments={departments} />
                <div className="mb-4 wp100">
                    <table className="table_style_1">
                        <thead>
                            <tr>
                                <th style={{ width: "80px" }} >S.No</th>
                                <th className="relative" style={{ width: "250px" }} >Skill Name
                                    <div className="sorting"><i className={sort === 'desc' ?
                                        'icon icon-sort-amount-asc' :
                                        'icon icon-sort-amount-desc'}
                                        onClick={handleSorting}
                                    ></i></div></th>
                                <th>Sub Skill Name</th>
                                <th>Division</th>
                                <th style={{ width: "180px" }}>Actions</th>
                            </tr>
                        </thead>
                        {loading ? (
                            <Loader />
                        ) : (
                            <tbody>

                                {filterSkillLists?.length > 0 ?
                                    filterSkillLists?.map((item, keys) => {
                                        return (
                                            <tr key={keys}>
                                                <td>{keys + 1}</td>
                                                <td>{item.group_name}</td>
                                                <td>{item.skill_name}</td>
                                                <td>{getDepartmentName(item.dept_id)}</td>
                                                <td>
                                                    <button
                                                        className="btn_7 mr03"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#addSkillSet"
                                                        onClick={() => handleUpdate(item)}
                                                    >
                                                        Edit
                                                    </button>
                                                    <button
                                                        className="btn_8"
                                                        onClick={() => handleDelete(item.skill_id)}
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                    :
                                    <tr>
                                        <td colSpan={5} className="text-center">
                                            <div className="notfound">No Record found</div>
                                        </td>
                                    </tr>
                                }

                            </tbody>
                        )}
                        {filterSkillLists?.length > 0 &&
                            <tfoot>
                                <tr>
                                    <td colSpan={5}>
                                        {totalPosts > postPerPage && (
                                            <Pagination
                                                currentPage={currentPage}
                                                setCurrentPage={setCurrentPage}
                                                totalPosts={totalPosts}
                                                postPerPage={postPerPage}
                                            />
                                        )}
                                    </td>
                                </tr>

                            </tfoot>
                        }
                    </table>


                </div>
            </div>
        </>
    )
}
export default Table;